import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

// Keep deployed kiosk bookmarks and links usable while presenting the current
// check-in vocabulary in the address bar. Redirects must retain draft state.
export const LEGACY_KIOSK_ROUTES = {
  '/reasons': '/kiosk/check-in/purpose',
  '/machine_selection': '/kiosk/check-in/tools',
  '/kiosk_success': '/kiosk/check-in/complete',
  '/thank_you': '/kiosk/check-out/complete',
};

export function isKioskPath(pathname) {
  return pathname === '/kiosk' || pathname.startsWith('/kiosk/') ||
    Object.prototype.hasOwnProperty.call(LEGACY_KIOSK_ROUTES, pathname.replace(/\/$/, ''));
}

export function KioskLegacyRedirect() {
  const location = useLocation();
  const pathname = LEGACY_KIOSK_ROUTES[location.pathname.replace(/\/$/, '')];
  return <Redirect to={{ ...location, pathname }} />;
}

// Keep kiosk setup parameters with the kiosk as it moves between steps. Never
// carry the kiosk key or space configuration into desktop/admin destinations.
export function kioskLocation(pathname, location) {
  return isKioskPath(pathname) ? { pathname, search: location.search } : pathname;
}
